<template>
    <div class="relative transition-all duration-500 pointer-events-none select-none w-full"
         ref="main"
         v-bind:style="{
             marginBottom: (cardHeight / 100 * perspectiveY * 1.11) + 'px',
             transform: 'scale(' + scale + ')',
         }">
        <div class="controls"
             v-bind:style="{marginTop: cardHeight / 100 * perspectiveY * 3 + 'px'}"
             v-if="controls">
            RotateX: <input max="360" min="-360" size="3" step="0.5" type="number" v-model="rotation.x"><br>
            RotateY: <input max="360" min="-360" size="3" step="0.5" type="number" v-model="rotation.y"><br>
            RotateZ: <input max="360" min="-360" size="3" step="0.5" type="number" v-model="rotation.z"><br>
            <br>
            PerspectiveX: <input max="100" min="-100" step="0.5" type="number" v-model="perspectiveX"><br>
            PerspectiveY: <input max="100" min="-100" step="0.5" type="number" v-model="perspectiveY"><br>
            <br>
            Zoom: <input step="0.5" type="number" v-model="zoom"><br>
            MoveX: <input max="100" min="-100" step="0.5" type="number" v-model="move.x"><br>
            MoveY: <input max="100" min="-100" step="0.5" type="number" v-model="move.y"><br>
            <br>
            Max width: <input max="100" min="0" size="3" step="0.5" type="number" v-model="settings.maxWidth"><br>
            <br>
            Grid: <input type="checkbox" v-model="grid"><br>
            Rotatable: <input type="checkbox" v-model="rotatable"><br>
            <br>
            Opened: <input max="360" min="-360" size="3" step="0.5" type="number" v-model="openedInput"><br>

            Container: {{ container }}<br>
            Images: {{ cardImageSize }}<br>
            Loaded: {{ loaded * 1 }}
        </div>
        <div v-show="!loaded"
             class="flex flex-wrap content-center h-full justify-center justify-items-center w-full"
             v-bind:style="{ height: cardHeight + 'px',
                             width: container.width + 'px' }">
            <div>
                <svg class="animate-spin h-24 w-24 text-primary-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
            </div>
        </div>
        <div v-if="loaded === 'error'"
             class="flex flex-wrap content-center h-full justify-center justify-items-center w-full"
             v-bind:style="{ height: container.height + 'px',
                             width: container.width + 'px' }">
            <p>An error occurred while loading the design.</p>
        </div>
        <div class="container"
             v-if="loaded === true"
             v-bind:style="{ height: cardHeight + 'px',
                             width: container.width/100*zoom + 'px',
                             marginBottom: (cardHeight/100*perspectiveY*1.05) + 'px',
                             marginLeft: (0-cardWidth/100*perspectiveX*1.05) + 'px',
                             perspective: perspective + 'px',
                             transform: 'translateX(' + containerCenterX + 'px)', }">
            <div class="cube pointer-events-auto"
                 v-bind:style="{ transform: 'rotateX(' + rotation.x + 'deg) ' +
                                            'rotateY(' + rotation.y + 'deg) ' +
                                            'rotateZ(' + rotation.z + 'deg) ' +
                                            'translateX(' + cardWidth/100*perspectiveX + 'px)' +
                                            'translateY(' + cardHeight/100*perspectiveY + 'px)',
                                 // transformOrigin: (this.openable ? 'left center' : null),
                                 transformOrigin: (this.openable ? 'left' : 'center') + ' ' + (cardHeight / 2 + cardHeight / 100 * perspectiveY) + 'px',
                                 marginTop: 0-cardHeight/100*perspectiveY+(container.width/100*zoom/100*move.y) + 'px',
                                 marginLeft: 0-cardWidth/100*perspectiveX + (container.width/100*zoom/100*move.x) + 'px',
                                 '--animation-name': animation.name ?? 'none',
                                 '--animation-duration': (animation.duration ?? 15) + 's',
                                 '--animation-timing': animation.timing ?? 'ease-in-out',
                                 '--animation-base-rotation-x': rotation.x + 'deg',
                                 '--animation-base-rotation-y': rotation.y + 'deg',
                                 '--animation-base-rotation-z': rotation.z + 'deg',
                                 '--animation-intensity': animation.intensity ?? 1,
                                 '--animation-state': animationState ?? 'running',
                                 }">
                <div class="cube-face cube-front"
                     v-bind:style="{ transform: 'rotateX(0deg) translateZ(' + cardTotalDepth/2 + 'px)'}"
                     v-if="grid"></div>
                <div class="cube-face cube-back"
                     v-bind:style="{ transform: 'rotateX(180deg) translateZ(' + cardTotalDepth/2 + 'px)'}"
                     v-if="grid"></div>
                <div class="cube-face cube-right"
                     v-bind:style="{ transform: 'rotateY(90deg) translateZ(' + container.width/2 + 'px)'}"
                     v-if="grid"></div>
                <div class="cube-face cube-left"
                     v-bind:style="{ transform: 'rotateY(-90deg) translateZ(' + container.width/2 + 'px)'}"
                     v-if="grid"></div>
                <div class="cube-face cube-top"
                     v-bind:style="{ transform: 'rotateX(90deg) translateZ(' + cardHeight/2 + 'px)'}"
                     v-if="grid"></div>
                <div class="cube-face cube-bottom"
                     v-bind:style="{ transform: 'rotateX(-90deg) translateZ(' + cardHeight/2 + 'px)'}"
                     v-if="grid"></div>

                <div class="card"
                     v-bind:style="{ transform: 'translateZ(' + cardCenterZ + 'px) translateX(' + cardCenterX + 'px)', }"
                     v-on:touchstart="modelStart"
                     v-on:mousedown="modelStart">
                    <div class="card-box-face card-box-back transition-shadow duration-500"
                         v-bind:class="{ 'custom-shadow' : shadows }"
                         v-bind:style="{ backgroundColor: item && item.background_color ? item.background_color : '#fff',
                                         height: cardHeight + 'px',
                                         left: cardLeft + 'px',
                                         top: cardTop + 'px',
                                         transform: 'rotateY(180deg) translateZ(' + cardDepth/2 + 'px)',
                                         width: cardWidth + 'px',
                                         zIndex: 1, }">
                        <img alt="3d model image"
                             class="transition-shadow duration-500 pointer-events-none"
                             v-bind:class="{ 'shadow-2xl' : shadows }"
                             v-bind:src="modelImage('back')">

                        <vcs-new-2d-model-outside-back v-bind:item="item"></vcs-new-2d-model-outside-back>
                        <vcs-new-2d-model-side ref="back"
                                               side="back"
                                               v-bind:editable="false"
                                               v-bind:format="format"
                                               v-bind:flipped="false"
                                               v-bind:language="language"
                                               v-if="(!design || design.status !== 'custom') &&
                                                     item &&
                                                     item.elements &&
                                                     item.elements.filter(element => element && element.side === 'back').length > 0"
                                               v-model="item.elements"></vcs-new-2d-model-side>
                    </div>
                    <div class="card-box-face card-box-front transition-shadow duration-500"
                         v-bind:class="{ 'custom-shadow' : shadows }"
                         v-bind:style="{
                                backgroundColor: item && item.background_color ? item.background_color : '#fff',
                                 height: cardHeight + 'px',
                                 left: cardLeft + 'px',
                                 transform: 'translateZ(' + cardDepth/2 + 'px)',
                                 top: cardTop + 'px',
                                 width: cardWidth + 'px', }">
                        <img alt="3d model image"
                             class="transition-shadow duration-500 pointer-events-none"
                             v-bind:class="{ 'shadow-2xl' : shadows }"
                             v-bind:src="modelImage('inside_right')">
                        <vcs-new-2d-model-inside-right ref="inside-right"
                                                       v-bind:autoplay="autoplay"
                                                       v-bind:format="format"
                                                       v-bind:item="item"
                                                       v-bind:language="language"
                                                       v-bind:size="size"
                                                       v-bind:video-placeholder="videoPlaceholder"
                                                       v-if="item"
                                                       v-on:control-click="modelPrevent"
                                                       v-on:enter-fullscreen="$emit('enter-fullscreen')"
                                                       v-on:exit-fullscreen="$emit('exit-fullscreen')">
                            <template v-slot:right="slotProps">
                                <slot></slot>
                            </template>
                        </vcs-new-2d-model-inside-right>
                        <img alt="3d model hands"
                             class="absolute left-full top-full pointer-events-none"
                             v-bind:src="handRight.src"
                             v-bind:style="{
                                height: 'auto',
                                transform: 'translateX(' + handRight.x + ') translateY(' + handRight.y + ')',
                                width: handRight.width,
                            }"
                             v-if="handRight && !hideHands.right">
                    </div>
                    <div class="card-box-face card-box-bottom"
                         v-bind:style="{ backgroundColor: item && item.background_color ? item.background_color : '#fff',
                                         height: cardDepth + 'px',
                                         left: cardLeft + 'px',
                                         transform: 'rotateX(90deg) rotateY(180deg)',
                                         top: cardTop+cardHeight-(cardDepth/2) + 'px',
                                         width: cardWidth + 'px', }">
                        <img alt="3d model image" class="pointer-events-none" v-bind:src="modelImage('bottom')">
                    </div>
                    <div class="card-box-face card-box-bottom-inside border-transparent border-2"
                         v-bind:style="{ backgroundColor: item && item.background_color ? item.background_color : '#fff',
                                         height: cardDepth-4 + 'px',
                                         left: cardLeft + 'px',
                                         transform: 'rotateX(90deg) rotateY(180deg)',
                                         top: cardTop+cardHeight-(cardDepth/2)-10 + 'px',
                                         width: cardWidth-4 + 'px', }"
                         v-if="rotatable">
                        <img alt="3d model image" class="pointer-events-none" v-bind:src="modelImage('bottom')">
                    </div>
                    <div class="card-box-face card-box-top"
                         v-bind:style="{ backgroundColor: item && item.background_color ? item.background_color : '#fff',
                                         height: cardDepth + 'px',
                                         left: cardLeft + 'px',
                                         transform: 'rotateY(180deg) rotateX(90deg)',
                                         top: cardTop-(cardDepth/2) + 'px',
                                         width: cardWidth + 'px', }">
                        <img alt="3d model image" class=" pointer-events-none" v-bind:src="modelImage('top')">
                    </div>
                    <div class="card-box-face card-box-top-inside border-transparent border-2"
                         v-bind:style="{ backgroundColor: item && item.background_color ? item.background_color : '#fff',
                                         height: cardDepth-4 + 'px',
                                         left: cardLeft + 'px',
                                         transform: 'rotateY(180deg) rotateX(90deg)',
                                         top: cardTop-(cardDepth/2)+10 + 'px',
                                         width: cardWidth-4 + 'px', }"
                         v-if="rotatable">
                        <img alt="3d model image" class="pointer-events-none" v-bind:src="modelImage('top')">
                    </div>
                    <div class="card-box-face card-box-right"
                         v-bind:style="{ backgroundColor: item && item.background_color ? item.background_color : '#fff',
                                         height: cardHeight + 'px',
                                         left: cardLeft+cardWidth-(this.cardDepth/2) + 'px',
                                         transform: 'rotateY(90deg)',
                                         top: cardTop + 'px',
                                         width: cardDepth + 'px', }">
                        <img alt="3d model image" class="pointer-events-none" v-bind:src="modelImage('right')">
                    </div>
                    <div class="card-box-face card-box-right-inside border-transparent border-2"
                         v-bind:style="{ backgroundColor: item && item.background_color ? item.background_color : '#fff',
                                         height: cardHeight-4 + 'px',
                                         left: cardLeft+cardWidth-(this.cardDepth/2)-10 + 'px',
                                         transform: 'rotateY(90deg)',
                                         top: cardTop + 'px',
                                         width: cardDepth-4 + 'px', }"
                         v-if="rotatable">
                        <img alt="3d model image" class="pointer-events-none" v-bind:src="modelImage('right')">
                    </div>
                    <div class="card-box-face card-box-left relative"
                         v-bind:style="{ backgroundColor: item && item.background_color ? item.background_color : '#fff',
                                         height: cardHeight + 'px',
                                         left: cardLeft-(cardDepth/2) + 'px',
                                         transform: 'rotateY(-90deg) translateZ(-0.6px)',
                                         transformStyle: 'preserve-3d',
                                         top: cardTop + 'px',
                                         width: cardDepth + 'px', }">
                        <div class="absolute h-full w-full"
                             v-bind:class="{ 'custom-shadow' : shadows && false }">
                            <img alt="3d model image"
                                 class="pointer-events-none"
                                 v-bind:src="modelImage('inside_side')"
                                 v-if="modelImage('inside_side')">
                        </div>
                        <div class="absolute"
                             v-bind:style="{
                                 backgroundColor: item && item.background_color ? item.background_color : '#fff',
                                 bottom: '0.1px',
                                 left: '0.1px',
                                 right: '0.1px',
                                 top: '0.1px',
                                 transform: 'rotateY(-' + flap.angle + 'deg)',
                                 transformOrigin: 'left',
                                 transformStyle: 'preserve-3d',
                             }">
                        </div>
                        <div class="absolute bg-white h-full w-full"
                             v-bind:class="{ 'custom-shadow' : shadows }"
                             v-bind:style="{
                                 transform: 'rotateY(-' + flap.angle + 'deg)',
                                 transformOrigin: 'left',
                                 transformStyle: 'preserve-3d',
                             }">
                            <img alt="3d model image"
                                 class="pointer-events-none"
                                 v-bind:src="modelImage('left')"
                                 v-bind:style="{
                                     transform: 'translateZ(0.1px)',
                                 }">
                        </div>
                    </div>
                    <div class="card-box-face card-box-left-inside border-transparent border-2"
                         v-bind:style="{ backgroundColor: item && item.background_color ? item.background_color : '#fff',
                                         height: cardHeight-4 + 'px',
                                         left: cardLeft-(cardDepth/2)+10 + 'px',
                                         transform: 'rotateY(-90deg) translateZ(-0.6px)',
                                         top: cardTop + 'px',
                                         width: cardDepth-4 + 'px', }"
                         v-if="rotatable">
                        <img alt="3d model image" class="pointer-events-none" v-bind:src="modelImage('left')">
                    </div>

                    <div class="card-flap"
                         v-bind:style="{ transform: 'translateZ(' + (cardDepth / 2 - flap.back) + 'px)' +
                                                    'translateX(-' + flap.left + 'px)', }">
                        <div class="card-flap-face card-flap-back"
                             v-bind:style="{ backgroundColor: item && item.background_color ? item.background_color : '#fff',
                                             height: cardHeight + 'px',
                                             left: cardLeft + 'px',
                                             top: cardTop + 'px',
                                             transform: 'rotateY(-' + opened + 'deg)',
                                             transformOrigin: '0 0',
                                             width: cardWidth + 'px', }">
                            <div class="flipped" style="transform: rotateY(-180deg) translateZ(-0.1px);">
                                <img alt="3d model image"
                                     class="absolute pointer-events-none"
                                     style="z-index: 1;"
                                     v-bind:src="modelImage('inside_left')">
                                <vcs-new-2d-model-side ref="inside-left"
                                                       side="inside-left"
                                                       v-bind:editable="false"
                                                       v-bind:format="format"
                                                       v-bind:flipped="false"
                                                       v-bind:language="language"
                                                       v-if="(!design || design.status !== 'custom') &&
                                                             item &&
                                                             item.elements &&
                                                             item.elements.filter(element => element && element.side === 'inside-left').length > 0"
                                                       v-model="item.elements"></vcs-new-2d-model-side>
                                <img alt="3d model hands"
                                     class="absolute right-full top-full z-20 pointer-events-none"
                                     v-bind:src="handLeft.src"
                                     v-bind:style="{
                                        height: 'auto',
                                        transform: 'translateX(' + handLeft.x + ') translateY(' + handLeft.y + ')',
                                        width: handLeft.width,
                                    }"
                                     v-if="handLeft && !hideHands.left">
                            </div>
                        </div>
                        <div class="card-flap-face card-flap-front transition-shadow duration-500"
                             v-bind:class="{ 'custom-shadow' : shadows }"
                             v-bind:style="{ backgroundColor: item && item.background_color ? item.background_color : '#fff',
                                             height: cardHeight + 'px',
                                             left: cardLeft + 'px',
                                             top: cardTop + 'px',
                                             transform: 'rotateY(-' + opened + 'deg) translateZ(0.1px)',
                                             transformOrigin: '0 0',
                                             width: cardWidth + 'px', }">
                            <div>
                                <img alt="3d model image"
                                     class="absolute transition-shadow pointer-events-none"
                                     style="z-index: 1;"
                                     v-bind:class="{ 'shadow-2xl' : shadows }"
                                     v-bind:src="modelImage('front')">
                                <vcs-new-2d-model-side ref="front"
                                                       side="front"
                                                       v-bind:editable="false"
                                                       v-bind:format="format"
                                                       v-bind:flipped="false"
                                                       v-bind:language="language"
                                                       v-if="(!design || design.status !== 'custom') &&
                                                             item &&
                                                             item.elements &&
                                                             item.elements.filter(element => element && element.side === 'front').length > 0"
                                                       v-model="item.elements"></vcs-new-2d-model-side>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="absolute flex h-full inset-0 items-center justify-center w-full pointer-events-none
                        font-bold text-3xl"
                 v-if="openable &&
                       openablePopover &&
                       !openablePopoverDismissed &&
                       loaded === true">
                Drag to open<br>
                <svg class="h-20 inline-block w-20"
                     xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256">
                    <path
                        d="M213.66,181.66l-32,32a8,8,0,0,1-11.32-11.32L188.69,184H48a8,8,0,0,1,0-16H188.69l-18.35-18.34a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,213.66,181.66Zm-139.32-64a8,8,0,0,0,11.32-11.32L67.31,88H208a8,8,0,0,0,0-16H67.31L85.66,53.66A8,8,0,0,0,74.34,42.34l-32,32a8,8,0,0,0,0,11.32Z"></path>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import gsap from 'gsap';
import {mapGetters} from "vuex";

export default {
    name: "vcs-new-3d-model",
    computed: {
        ...mapGetters('vcsVideos', [
            'videos',
        ]),
        cardDepth: function () {
            return this.cardWidth * this.ratios[this.format].depth;
        },
        cardHeight: function () {
            return this.cardWidth * this.ratios[this.format].height;
        },
        cardLeft: function () {
            return (this.container.width - this.cardWidth) / 2;
        },
        cardTop: function () {
            return (this.cardHeight - this.cardHeight) / 2;
        },
        cardWidth: function () {
            var cardWidth = 100;
            var cardFlapWidth = 0;
            if (this.opened > 90 && this.keepInContainer)
                cardFlapWidth = cardWidth * Math.sin((this.opened - 90) * Math.PI / 180) / Math.sin(90 * Math.PI / 180)
            var cardFullWidth = cardWidth + cardFlapWidth;
            var widthPercentage = 100 * cardWidth / cardFullWidth;
            if (widthPercentage > this.settings.maxWidth)
                widthPercentage = this.settings.maxWidth;
            var width = this.container.width / 100 * this.zoom / 100 * widthPercentage;
            return width;
            return this.card.width;
        },

        cardFlapDepth: function () {
            return this.cardWidth * Math.sin(this.opened * Math.PI / 180) * Math.sin(90 * Math.PI / 180);
        },
        cardFlapWidth: function () {
            if (this.opened > 90)
                return this.cardWidth * Math.sin((this.opened - 90) * Math.PI / 180) / Math.sin(90 * Math.PI / 180)
            return 0;
        },

        cardTotalDepth: function () {
            return this.cardDepth + this.cardFlapDepth;
        },

        cardImageSize: function () {
            if (this.imageSize)
                return this.imageSize;
            if (typeof this.image_sizes == 'undefined')
                return '';
            for (var key in this.image_sizes) {
                var size = this.image_sizes[key];
                if (size.width >= this.container.width)
                    return size.name;
            }
            return 'original';
        },

        size: function () {
            if (this.item &&
                this.item.size)
                return this.item.size;
            if (this.item &&
                this.item.product &&
                this.item.product.sizes &&
                this.item.product.sizes[0])
                return this.item.product.sizes[0];
            if (this.previewSize)
                return this.previewSize;
        },

        cardCenterX: function () {
            if (!this.openable &&
                this.rotatable)
                return (this.cardFlapWidth / 2);

            return 0;
        },
        cardCenterZ: function () {
            if (!this.openable &&
                this.rotatable)
                return -(this.cardFlapDepth / 2);

            return 0
        },

        containerCenterX: function () {
            if (this.openable) {
                if (this.rotation.y < -69)
                    return this.cardWidth;
                return this.cardWidth / -69 * this.rotation.y;
            }
            if (this.rotatable)
                return 0;
        },

        video: function () {
            if (!this.configuration.videos[
                this.videoIndex
                ])
                return null;

            if (!this.videos[
                this.configuration.videos[
                    this.videoIndex
                    ]
                ])
                return null;

            return this.videos[
                this.configuration.videos[
                    this.videoIndex
                    ]
                ];
        },

        storageDomain: function () {
            return window.storage_url;
            var domain = window.location.hostname.split('.');
            if (domain.length === 2)
                return 'https://storage.' + domain[0] + '.' + domain[1];
            return 'https://storage.' + domain[1] + '.' + domain[2];
        },
    },
    created() {
        this.created = true;
    },
    data: function () {
        return {
            animationState: 'running',
            debounceTimer: null,
            design: {},
            opened: 0,
            openedInput: 0,
            configuration: {},
            container: {
                height: 0,
                width: 0,
            },
            created: false,
            flap: {
                angle: 0,
                back: 0,
                left: 0,
            },
            hideHands: {
                left: false,
                right: false,
            },
            image_sizes: [
                {
                    name: "sm",
                    width: 274
                },
                {
                    name: "md",
                    width: 342
                },
                {
                    name: "lg",
                    width: 342
                },
                {
                    name: "xl",
                    width: 334
                },
                {
                    name: "xxl",
                    width: 532
                },
                {
                    name: "retina",
                    width: 1064
                },
            ],
            loaded: false,
            loaded_count: 0,
            loaded_fails: 0,
            move: {
                x: 0,
                y: 0,
            },
            opening: null,
            openingState: 0,
            openablePopoverDismissed: false,
            ratios: {
                'a5-landscape': {
                    depth: 1 / 210 * 8,
                    height: 1 / 210 * 148,
                },
                'a5-portrait': {
                    depth: 1 / 210 * 8,
                    height: 1 / 210 * 297,
                },
            },
            rotation: {
                x: 0,
                y: 0,
                z: 0,
            },
            rotate: null,
            scale: 1,
            settings: {
                maxWidth: 100,
                opening: {
                    x: {
                        degrees: 1,
                        round: 1,
                    },
                    y: {
                        degrees: 0.9,
                        deadzone: 0,
                        round: 1,
                    },
                },
                rotation: {
                    x: {
                        degrees: 1,
                        round: 1,
                    },
                    y: {
                        degrees: 1,
                        round: 1,
                    },
                },
            },
            videoIndex: 0,
            zoom: 100,
        };
    },
    methods: {
        debounce: function (func) {
            return function (event) {
                if (this.debounceTimer)
                    clearTimeout(this.debounceTimer);
                this.debounceTimer = setTimeout(func, 250, event);
            };
        },
        getElementStyle: function (element, ref, positioning = true) {
            // Init style
            var style = {};

            // Add positioning
            if (positioning) {
                style.height = (this.cardHeight / 100 * element.height) + 'px';
                style.left = (this.cardWidth / 100 * element.left) + 'px';
                style.top = (this.cardHeight / 100 * element.top) + 'px';
                style.width = (this.cardWidth / 100 * element.width) + 'px';

                style.transform = 'translateX(-50%) ' +
                    'translateY(-50%) ' +
                    'rotateZ(' + element.angle + 'deg) ';
            }
            ;

            // Init text style
            if (element.type == 'text') {
                style.color = element.style.color;
                style.fontFamily = element.style.font;
                style.fontSize = this.cardHeight / 100 * element.style.size + 'px';
                style.fontWeight = (element.style.bold ? 'bold' : 'normal');
                style.textDecoration = (element.style.underline ? 'underline' : 'none');
                style.fontStyle = (element.style.italic ? 'italic' : 'normal');

                // style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
                // style.padding = '10px';
                // style.borderRadius = '10px';
            }

            // Return style
            return style;
        },

        modelImage: function (image) {
            if (!this.container.width)
                return '#';

            if (!this.designLoad)
                return this.storageDomain + '/designs/' + this.designUuid + '/image_' + image + '/' + this.cardImageSize + this.uncachedUrl;
            // return 'https://development.videocardstore.com/storage/designs/' + this.designUuid + '/image_' + image + '/' + this.cardImageSize + this.uncachedUrl;

            if (this.design == null ||
                typeof this.design['image_' + image] === 'undefined')
                return '#';
            return this.design['image_' + image][this.cardImageSize] + this.uncachedUrl;
        },

        modelOpen: function (newValue) {
            this.openedInput = newValue;
            this.openingState = newValue;
        },
        modelRotate: function (x, y, z) {

            gsap.to(this.rotation, {
                delay: 0.5,
                duration: 1.5,
                ease: "power4.out",
                x: Number(x),
                y: Number(y),
                z: Number(z),
            });
        },
        modelScale: function (scale) {
            this.scale = scale;
        },

        modelEnd: function (e) {
            if (this.openable)
                return this.modelOpenEnd(e);
            if (this.rotatable)
                return this.modelRotateEnd(e);
        },
        modelMove: function (e) {
            if (this.openable)
                return this.modelOpenMove(e);
            if (this.rotatable)
                return this.modelRotateMove(e);
        },
        modelPrevent: function () {
            if (this.openable)
                return this.modelOpenPrevent();
            if (this.rotatable)
                return this.modelRotatePrevent();
        },
        modelStart: function (e) {
            this.openablePopoverDismissed = true;

            if (this.openable)
                return this.modelOpenStart(e);
            if (this.rotatable)
                return this.modelRotateStart(e);
        },

        modelOpenEnd: function (e) {
            setTimeout(() => {
                // Detect a click
                if (this.opening &&
                    !this.opening.moved &&
                    e.timeStamp - this.opening.time < 250) {
                    if (this.openingState < 90)
                        this.openingState = 90;
                    else if (this.openingState >= 90 &&
                        this.openingState < 165)
                        this.openingState = 165;
                    else if (this.openingState >= 165 &&
                        this.openingState < 270)
                        this.openingState = 270;
                    else if (this.openingState >= 270)
                        this.openingState = 0;
                    this.modelOpenMoveExecute(this.openingState, true);
                }

                // End opening
                this.opening = null;
            }, 5);
        },
        modelOpenMove: function (e) {
            // e.preventDefault();

            // Dont do anything if not mousedown
            if (this.opening === null)
                return;

            // x and y for mouse
            var position = this.modelGetPointerPosition(e);

            // Calculate opening
            var movementX = Math.floor((this.opening.cursor.x - position.x) / this.settings.opening.x.round);
            var opened = this.opening.start + (movementX * this.settings.opening.x.degrees);
            if (opened < 0)
                opened = 0;
            if (opened > 270)
                opened = 270;

            this.openingState = opened;

            this.modelOpenMoveExecute(opened);
            this.opening.moved = true;

            if (!this.rotatable)
                return;

            // Vertical rotation
            var movementY = Math.floor((this.opening.cursor.y - position.y) / this.settings.opening.y.round); // In steps of 10 px

            if (Math.abs(movementY) < this.settings.opening.y.deadzone)
                return;

            if (movementY > 0)
                movementY -= this.settings.opening.y.deadzone;
            else
                movementY += this.settings.opening.y.deadzone;

            this.rotation.x = this.opening.rotation.x + (movementY * this.settings.opening.y.degrees); // Rotate 10 degrees per step
        },
        modelOpenMoveExecute: function (opened, animated = false, y = null) {
            this.openingState = opened;
            this.openablePopoverDismissed = true;

            var rotateY = this.rotation.y;
            if (y !== null)
                rotateY = y;

            if (this.openable) {
                if (opened > 90)
                    rotateY = 90 - opened;
                if (rotateY < -180)
                    rotateY = -180;
                if (opened > 135)
                    opened = 135 - (opened - 135);
            }

            if (animated) {
                gsap.to(this, {
                    duration: 1,
                    ease: "power4.out",
                    opened: Number(opened) || 0
                });
                gsap.to(this.rotation, {
                    duration: 1,
                    ease: "power4.out",
                    y: Number(rotateY) || 0
                });
            } else {
                this.opened = opened;
                this.rotation.y = rotateY;
            }
        },
        modelOpenPrevent: function () {
            this.opening = null;
        },
        modelOpenStart: function (e) {
            // Disabled
            if (!this.openable)
                return;

            // Prevent parent element mouse events
            if (this.openable) {
                e.preventDefault();
                e.stopPropagation();
            }

            if (e.target.tagName == 'TEXTAREA')
                return;

            if (this.opening)
                return;

            // x and y for mouse
            var position = this.modelGetPointerPosition(e);

            this.opening = {
                cursor: {
                    x: position.x,
                    y: position.y,
                },
                moved: false,
                opened: this.opened * 1,
                rotation: Object.assign({}, this.rotation),
                start: this.openingState,
                time: e.timeStamp,
            };
        },

        modelRotateEnd: function (e) {
            this.rotate = null;
        },
        modelRotateMove: function (e) {
            // e.preventDefault();

            // Dont do anything if not mousedown
            if (this.rotate === null)
                return;

            // x and y for mouse
            var position = this.modelGetPointerPosition(e);

            var movementX = Math.floor((this.rotate.cursor.x - position.x) / this.settings.rotation.x.round); // In steps of 10 px
            var movementY = Math.floor((this.rotate.cursor.y - position.y) / this.settings.rotation.y.round); // In steps of 10 px

            this.rotation.x = this.rotate.rotation.x + (movementY * this.settings.rotation.y.degrees); // Rotate 10 degrees per step
            this.rotation.y = this.rotate.rotation.y - (movementX * this.settings.rotation.x.degrees); // Rotate 10 degrees per step
        },
        modelRotatePrevent: function () {
            this.rotate = null;
        },
        modelRotateStart: function (e) {
            // Disabled
            if (!this.rotatable)
                return;

            // Prevent parent element mouse events
            if (this.rotatable) {
                e.preventDefault();
                e.stopPropagation();
            }

            if (e.target.tagName == 'TEXTAREA')
                return;

            if (this.rotate)
                return;

            // x and y for mouse
            var position = this.modelGetPointerPosition(e);

            this.rotate = {
                cursor: {
                    x: position.x,
                    y: position.y,
                },
                rotation: Object.assign({}, this.rotation),
            };
        },
        modelGetPointerPosition: function (e) {
            // x and y for mouse
            var x = e.x;
            var y = e.y;

            // Check for touch
            if (e.changedTouches && e.changedTouches.length > 0) {
                x = e.touches[0].pageX;
                y = e.touches[0].pageY;
            }

            return {
                x: x,
                y: y,
            };
        },

        controlsClick: function (button) {
            if (Object.keys(this.configuration.videos).length > 1 &&
                (button == 'next' || button == 'previous')) {
                if (button == 'next' && this.videoIndex < this.configuration.videos.length - 1)
                    this.videoIndex++;
                if (button == 'previous' && this.videoIndex > 0)
                    this.videoIndex--;
                return;
            }

            // Send event to video player
            button = button.replace(/([-_][a-z])/ig, ($1) => {
                return $1.toUpperCase()
                    .replace('-', '')
                    .replace('_', '');
            });
            button = button[0].toUpperCase() + button.slice(1);

            if (typeof this.$refs['model-video']['video' + button] != 'undefined')
                this.$refs['model-video']['video' + button]();
        },

        preloadImages: function () {
            // Reset loaded state
            // this.loaded = false;
            this.loaded_count = 0;

            // Load image promise
            const loadImage = (url) => new Promise((resolve, reject) => {
                this.loading++;

                const img = new Image();
                img.addEventListener('load', () => {
                    this.loaded_count++;
                    resolve(img);
                });
                img.addEventListener('error', (err) => {
                    if (url !== '#')
                        console.log('Failed to load 3d-model image', url, JSON.stringify(err));
                    reject(err);
                });
                img.src = url;
            });

            // Init promises collection
            var promises = [];

            // Iterate images
            for (var key in {
                back: '',
                bottom: '',
                front: '',
                inside_left: '',
                inside_right: '',
                left: '',
                right: '',
                top: '',
            })
                promises.push(loadImage(this.modelImage(key)));

            // Process loaded state
            Promise.all(promises)
                .then((values) => {
                    this.loaded = true;
                    this.$emit('loaded');
                })
                .catch((values) => {
                    this.loaded_fails++;

                    if (this.loaded_fails >= 3)
                        this.loaded = 'error';
                    else
                        setTimeout(this.preloadImages, 2500);

                });
        },
        updateContainer: function () {
            if (!this.$refs.main)
                return setTimeout(this.updateContainer, 100);

            const style = window.getComputedStyle(this.$refs.main);
            this.container.width = style.getPropertyValue('width').replace('px', '')
                - style.getPropertyValue('margin-left').replace('px', '')
                - style.getPropertyValue('margin-right').replace('px', '');

            if (!this.container.width)
                return setTimeout(this.updateContainer, 100);

            // Preload images
            if (this.loaded)
                this.preloadImages();
        },

        demoTextArea: function (value) {
            this.configuration.elements = [];
            this.$forceUpdate();

            if (value)
                this.configuration.elements = [
                    {
                        // Define location
                        area: 'inside-left',

                        // Define tag
                        tag: 'div',

                        // Size config
                        size: null,
                        size_id: 0,

                        // Positioning
                        angle: -2,
                        height: 80,
                        left: 60,
                        top: 50,
                        width: 56,

                        // Element config
                        aspect_ratio: true,
                        style: {
                            bold: false,
                            color: '#000000',
                            font: 'arial',
                            italic: false,
                            size: 4,
                            underline: false,
                        },
                        type: 'text',
                        value: 'Hi!',
                    },
                ];
        },

        hideHand: function (side, value = true) {
            this.hideHands[side] = value;
        },
        pauseAnimation: function () {
            this.animationState = 'paused';
        },
        playAnimation: function () {
            this.animationState = 'running';
        },

    },
    mounted() {
        // Disable loading
        if (this.withoutLoader)
            this.loaded = true;

        // Manage cache
        this.uncachedUrl = (this.uncached ? '?' + (new Date).getTime() : '');

        // Update container size
        this.updateContainer();
        window.addEventListener('resize', this.debounce(this.updateContainer));

        // Process v-model input
        this.configuration = this.value;

        // Init default rotation
        if (this.initialRotation)
            for (var key in this.initialRotation)
                this.rotation[key] = this.initialRotation[key];

        // Init default opened
        if (this.initialOpened)
            this.openedInput = this.initialOpened;

        // Init default max width
        if (this.initialMaxWidth)
            this.settings.maxWidth = this.initialMaxWidth;

        // Init default scale
        if (this.initialScale)
            this.scale = this.initialScale;

        // Load preview data
        if (!this.itemUuid && this.previewSize)
            this.$set(this.configuration, 'size', this.previewSize);
        if (!this.itemUuid && this.previewVideo)
            this.$set(this.configuration.videos, 0, this.previewVideo);

        // Load item
        if (this.itemUuid)
            Vue.axios.get('/api/item/' + this.itemUuid)
                .then((response) => {
                    this.item = response.data;

                    if (this.previewSize && this.previewVideo) {
                        this.$set(this.value, 'size', this.previewSize);
                        this.$set(this.value, 'video', this.previewVideo);
                    }
                });

        if (this.designUuid &&
            this.designLoad)
            Vue.axios.get((typeof this.designLoad === 'string' ? this.designLoad : '/api/design/' + this.designUuid) + this.uncachedUrl)
                .then((response) => {
                    this.design = response.data.design;

                    if (this.item === null)
                        this.$emit('item', {
                            elements: this.design.elements,
                            size: response.data.size,
                        });
                });

        if (!this.designLoad && !this.loaded)
            this.preloadImages();

        // Init move events for rotation
        window.addEventListener('mousemove', this.modelMove);
        window.addEventListener('mouseup', this.modelEnd);

        window.addEventListener('touchmove', this.modelMove);
        window.addEventListener('touchend', this.modelEnd);
    },
    props: {
        animated: {
            default: true,
            required: false,
            type: Boolean,
        },
        animation: {
            default: () => {
                return {
                    duration: null,
                    timing: null,
                    name: null,
                }
            },
            required: false,
            type: Object,
        },
        autoplay: {
            default: false,
            required: false,
            type: Boolean,
        },
        controls: {
            default: false,
            required: false,
            type: Boolean,
        },
        designLoad: {
            default: true,
        },
        designUuid: {
            default: null,
            required: false,
            type: String,
        },
        editable: {
            default: false,
            required: false,
            type: Boolean,
        },
        embed: {
            default: null,
            required: false,
            type: String,
        },
        format: {
            default: 'a5-landscape',
            required: false,
            type: String,
        },
        grid: {
            default: false,
            required: false,
            type: Boolean,
        },
        handLeft: {
            default: null,
            required: false,
            type: Object,
        },
        handRight: {
            default: null,
            required: false,
            type: Object,
        },
        imageSize: {
            default: null,
            required: false,
        },
        initialOpened: {
            default: null,
            required: false,
            type: Number,
        },
        initialMaxWidth: {
            default: 100,
            required: false,
            type: Number,
        },
        initialRotation: {
            required: false,
            type: Object,
        },
        initialScale: {
            default: 1,
            required: false,
            type: Number,
        },
        item: {
            default: null,
            required: false,
            type: Object,
        },
        itemUuid: {
            default: null,
            required: false,
            type: String,
        },
        language: {
            default: 'en',
            required: false,
            type: String,
        },
        keepInContainer: {
            default: true,
            required: false,
            type: Boolean,
        },
        loop: {
            default: false,
            required: false,
            type: Boolean,
        },
        muted: {
            default: true,
            required: false,
            type: Boolean,
        },
        openable: {
            default: false,
            required: false,
            type: Boolean,
        },
        openablePopover: {
            default: false,
            required: false,
            type: Boolean,
        },
        perspective: {
            default: 1000,
            required: false,
            type: Number,
        },
        perspectiveX: {
            default: 0,
            required: false,
            type: Number,
        },
        perspectiveY: {
            default: 0,
            required: false,
            type: Number,
        },
        previewSize: {
            required: false,
            type: Object,
        },
        previewVideo: {
            required: false,
            type: Object,
        },
        rotatable: {
            default: true,
            required: false,
            type: Boolean,
        },
        rotating: {
            default: false,
            required: false,
            type: Boolean,
        },
        shadows: {
            default: true,
            required: false,
            type: Boolean,
        },
        uncached: {
            default: false,
            type: Boolean,
        },
        value: {
            default: () => {
                return {};
            },
            required: false,
            type: Object,
        },
        videoPlaceholder: {
            default: null,
            required: false,
            type: String,
        },
        withoutLoader: {
            default: false,
            required: false,
            type: Boolean,

        },
    },
    watch: {
        design: {
            deep: true,
            handler: function (newVal, oldVal) {
                if (newVal)
                    this.preloadImages();
            },
        },
        opened: {
            handler: function (newVal, oldVal) {
                const angleC = newVal / 2;
                const angleC_rad = (angleC * Math.PI) / 180;
                const angleC_sin = Math.sin(angleC_rad);

                const sideA = this.cardDepth;
                const sideB = this.cardDepth;

                const sideC = Math.sqrt(Math.pow(sideB, 2) + Math.pow(sideA, 2) - 2 * sideA * sideB * Math.cos(angleC_rad));
                const angleA_rad = Math.acos((Math.pow(sideC, 2) + Math.pow(sideB, 2) - Math.pow(sideA, 2)) / (2 * sideC * sideB));
                const angleB_rad = Math.acos((Math.pow(sideC, 2) + Math.pow(sideA, 2) - Math.pow(sideB, 2)) / (2 * sideC * sideA));

                const angleA = angleA_rad * (180 / Math.PI);
                const angleB = angleB_rad * (180 / Math.PI);

                const angleX = 90;
                const angleY = 90 - angleB
                const angleZ = 180 - angleX - angleY;

                const sideU = sideC;

                const angleX_rad = (angleX * Math.PI) / 180;
                const angleY_rad = (angleY * Math.PI) / 180;
                const angleZ_rad = (angleZ * Math.PI) / 180;

                // Calculate sin(C) and sin(B)
                const sinX = Math.sin(angleX_rad);
                const sinY = Math.sin(angleY_rad);
                const sinZ = Math.sin(angleZ_rad);

                const sideV = sideU * sinY / sinX;
                const sideW = sideU * sinZ / sinX;

                this.flap.angle = angleC;
                this.flap.left = !isNaN(sideW) ? Math.round(sideW) : 0;
                this.flap.back = !isNaN(sideV) ? Math.round(sideV) : 0;

            },
        },
        openedInput: {
            handler: function (newVal, oldVal) {
                if (newVal > 180 ||
                    newVal < 0)
                    this.openedInput = oldVal;

                if (this.animated)
                    return gsap.to(this, {
                        delay: 0.5,
                        duration: 1.5,
                        ease: "power4.out",
                        opened: Number(newVal) || 0
                    });

                this.opened = newVal;
            },
        },
        value: {
            deep: true,
            handler: function (newVal, oldVal) {
                this.configuration = newVal;

                if (typeof this.configuration.videos == 'array')
                    while (this.videoIndex > this.configuration.videos.length - 1)
                        this.videoIndex--;
            },
        },
        zoom: {
            handler: function (newVal, oldVal) {
                if (this.$refs['inside-left'])
                    this.$refs['inside-left'].$forceUpdate();
            },
        },
    },
}
</script>

<style>
.controls {
    background-color: #fff;
    border-color: #000;
    border-radius: 10px;
    border-width: 2px;
    bottom: 0;
    font-size: 10px;
    padding: 5px;
    pointer-events: auto;
    position: absolute;
    right: 0;
    z-index: 50000;
}

.cube {
    transform-style: preserve-3d;
    width: 100%;
    height: 100%;
    position: relative;
    animation: card-move-natural 10s infinite ease-in-out;
    animation-duration: var(--animation-duration);
    animation-timing-function: var(--animation-timing);
    animation-iteration-count: infinite;
    animation-play-state: var(--animation-state);
    animation-name: var(--animation-name);
}

.cube-face {
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: repeating-linear-gradient(0deg, rgba(70, 70, 70, 0.2) 0px, rgba(70, 70, 70, 0.2) 1px, transparent 1px, transparent 21px), repeating-linear-gradient(90deg, rgba(70, 70, 70, 0.2) 0px, rgba(70, 70, 70, 0.2) 1px, transparent 1px, transparent 21px), linear-gradient(90deg, rgb(255, 255, 255), rgb(255, 255, 255));
    opacity: .5;
}

.card {
    transform-style: preserve-3d;
    position: absolute;
}

.card-box-face {
    position: absolute;
}

.card-box-face img {
    height: 100%;
    width: 100%;
}

.card-flap {

    transform-style: preserve-3d;
    position: absolute;
}

.card-flap-face {
    transform-origin: 0 0;
    position: absolute;
}

.card-flap-face img {
    height: 100%;
    width: 100%;
}

.flipped {
    height: 100%;
    transform: translateZ(0.01px) rotateY(-180deg);
    transform-origin: 50% 50%;
    width: 100%;
}

.custom-shadow {
    box-shadow: 0px 0px 1px 1px rgb(0 0 0 / 10%)
}

@keyframes card-move-natural {
    0% {
        transform: rotateX(var(--animation-base-rotation-x)) rotateY(var(--animation-base-rotation-y));
    }
    25% {
        transform: rotateX(calc(var(--animation-base-rotation-x) + (2.5deg * var(--animation-intensity)))) rotateY(calc(var(--animation-base-rotation-y) + (-7deg * var(--animation-intensity))));
    }
    50% {
        transform: rotateX(calc(var(--animation-base-rotation-x) + (-7.5deg * var(--animation-intensity)))) rotateY(calc(var(--animation-base-rotation-y) + (3deg * var(--animation-intensity))));
    }
    75% {
        transform: rotateX(calc(var(--animation-base-rotation-x) + (1.5deg * var(--animation-intensity)))) rotateY(calc(var(--animation-base-rotation-y) + (-2deg * var(--animation-intensity))));
    }
    100% {
        transform: rotateX(var(--animation-base-rotation-x)) rotateY(var(--animation-base-rotation-y));
    }
}
</style>
